// client/src/api/client.ts
import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';

const clearStoredSession = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('tempToken');
};

export const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 60000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle token refresh
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: AxiosError) => {
    const responseData = error.response?.data as {
      success?: boolean;
      message?: string;
      accountStatus?: string;
      shouldLogout?: boolean;
    } | undefined;

    if (
      error.response?.status === 403 &&
      responseData?.shouldLogout === true &&
      responseData?.accountStatus === 'suspended' &&
      responseData?.message === 'Your account has been suspended. Please contact support.'
    ) {
      clearStoredSession();

      if (window.location.pathname !== '/signin') {
        window.location.href = '/signin';
      }

      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      // If we're already trying to logout, don't try to force a hard redirect
      if (error.config?.url === '/auth/logout') {
        return Promise.reject(error);
      }

      console.log('Session expired, redirecting to signin');
      clearStoredSession();
      if (window.location.pathname !== '/signin') {
        window.location.href = '/signin';
      }
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
